import React, { useState, useContext, useEffect } from "react";
import { motion } from "framer-motion";
import "./Login.css";
import logo from "../../assets/Logo.webp";
import logoText from "../../assets/logo-text-only.webp";
import { useNavigate, NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import AuthContext from "../../AuthContext";
import { FaEye, FaEyeSlash } from "react-icons/fa";

// Para desarrollo con el nuevo Auth Service
import AuthService from "../../services/auth.service.js";

const currentEnv = process.env.REACT_APP_ENV;
const isLoginDisabled = currentEnv === "prod" || currentEnv === "test";

export default function Login() {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { authenticateUser, isAuthenticated, loginWithJWT, isUsingJWT } = useContext(AuthContext);

  // REDIRECCIÓN SI YA ESTÁ AUTENTICADO
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleRememberMeChange = (e) => {
    setRememberMe(e.target.checked);
  };

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      return;
    }

    try {
      // Intentar con el nuevo Auth Service JWT
      if (loginWithJWT) {
        const result = await loginWithJWT(formData.email, formData.password);
        
        // Verificar que el login fue exitoso
        if (result && result.user && result.user.user_id) {
          navigate("/");
          return;
        }
      }
    } catch (error) {
      // Error silencioso
    }
  };

  return (
    <div className="login-container">
      <div className="brand-container">
        <div className="logo-wrapper">
          <img src={logo} alt="Zenit AI Logo" className="logo" />
          <img src={logoText} alt="Zenit AI" className="logo-text" />
        </div>
      </div>

      <div className="login-box">
        <form onSubmit={handleSubmit} className="login-form">
          <div className="input-container">
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-container password-container">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <span className="password-icon" onClick={toggleShowPassword}>
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <div className="form-options">
            <label className="remember-me">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={handleRememberMeChange}
              />
              <span>Remember me</span>
            </label>
            <NavLink to="/ForgotPassword" className="forgot-password">
              Forgot Password?
            </NavLink>
          </div>

          <button type="submit" className="login-btn">
            Login
          </button>
        </form>

        <div className="signup-link">
          Don't have an account? <NavLink to="/SignUp">Sign Up</NavLink>
        </div>
      </div>
    </div>
  );
}
